module.exports = __webpack_public_path__ + "img/circle_burgundy.7b8fc095.svg";